import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import Permissions from '@/common/permissions';
import { API_URL } from '@/dtos';
import useHasAccess from '@/modules/core/hooks/useHasAccess';

import { PayrollGroup } from '../payrollGroup.types';

export const QUERY_KEY = 'useGetPayrollGroupsQueryKey';

export const useGetPayrollGroupsQuery = (orgId?: string) => {
  const hasAccess = useHasAccess([
    { permission: Permissions.EDIT_ER_DATA },
    { permission: Permissions.VIEW_ER },
  ]);

  const { isLoading, error, data, isSuccess, isError, refetch } = useQuery(
    [QUERY_KEY, orgId],
    () => api.get(API_URL.PAYROLL_GROUPS_ORGANIZATIONS_BY_ORG_ID(orgId || '')),
    {
      enabled: !!orgId && hasAccess,
    }
  );

  const total = useMemo(() => data?.data?.length || 0, [data]);
  const updatedData = useMemo(() => data?.data, [data]);
  const formattedData = useMemo(
    () =>
      data?.data?.map(
        (item): PayrollGroup => ({
          id: toString(item.id),
          name: item.name,
          code: item.code,
          createdAt: item?.created_at as unknown as string,
          organizationId: toString(item?.organization_id),
          organizationPath: item?.organization_path,
        })
      ) || [],
    [data]
  );
  return {
    formattedData,
    data: updatedData,
    total,
    error,
    isError,
    isLoading,
    isSuccess,
    refetch,
  };
};
